import { render, staticRenderFns } from "./ModuleInProgress.vue?vue&type=template&id=56cb017a&scoped=true&"
import script from "./ModuleInProgress.vue?vue&type=script&lang=js&"
export * from "./ModuleInProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cb017a",
  null
  
)

export default component.exports